import React, { Component } from 'react'
import { BrowserRouter as Router, Route, Link } from 'react-router-dom'
import { Redirect } from 'react-router';
import './App.css';
import './W3.css';
import self_image from './resources/me.jpg'
import github_icon from './resources/github.png'
import github_icon_white from './resources/github_white.png'
import devpost_icon from './resources/devpost.png'
import linkedin_icon from './resources/linkedin.png'

import searchandpro_panel from './resources/searchandpro.png'
import senior_panel from './resources/senior.jpg'
import p2s_panel from './resources/p2s.png'
import watson_panel from './resources/watson.jpg'
import giphy_panel from './resources/giphy.jpg'
import talcum_panel from './resources/talcum.jpg'
import alexa_panel from './resources/alexa.jpg'
import simulator_panel from './resources/simulator.jpg'


import eye_panel from './resources/eye.png'
import eye_phone_panel from './resources/eye_phone.png'
import discord_panel from './resources/discord.png'
import userscript_panel from './resources/reddit-script.jpg'
import keyboard_panel from './resources/keyboard.png'
import uwaterloo_panel from './resources/uwaterloo.png'
import mal_panel from './resources/mal.png'
import hearthstone_panel from './resources/hearthstone.png'
import clap_panel from './resources/clap.jpg'




const App = () => (
  <Router>
    <div>
      <Route exact path="/" component={Home} />
      <Route path={process.env.PUBLIC_URL + '/hackathons'} component={Hackathons} />
      <Route path={process.env.PUBLIC_URL + '/projects'} component={Projects} />
    </div>
  </Router>
);

const Home = (props) => {
  return (
    <div className="App">
      <img className="ProfileImage" alt={"Haoyang Zhu"} src={self_image} />
      <h1>Steve Zhu</h1>
      <h4>Computer Science and Business Administration</h4>
      <br/>
      <a href="https://github.com/hygzhu"><img alt={"Github"} src={github_icon} className="LinkIcon" /></a>
      <a href="https://devpost.com/hygzhu"><img alt={"Devpost"} src={devpost_icon} className="LinkIcon" /></a>
      <a href="https://www.linkedin.com/in/hygzhu/"><img alt={"Linkedin"} src={linkedin_icon} className="LinkIcon" /></a>
      <br />
      <br />
      <Link to="/hackathons"><h3>Hackathon Projects</h3></Link>
      <Link to="/projects"><h3>Personal Projects</h3></Link>
      <br />
      <br />
      <a href="https://drive.google.com/file/d/1diFnlQILKQtiYG-QX_FZCgP37m1pVIro/view"><h3>View Resume</h3></a>
    </div>);
}

const Hackathons = (props) => {
  return (
    <div>
      <button className="ViewProjectsButton" onClick={() => window.location.assign("\\")}>Back</button>
      <div class="w3-main">


        <div class="w3-row w3-padding-64">
          <div class="w3-twothird w3-container">
            <h1>Hackathon Simulator</h1>
            <p>A 2D game that simulates the experience of a Hack the North participant Made with C++. Won Ubisofts Hackers Nest API Prize.</p>
            <p><b>Github:</b><a href="https://github.com/hygzhu/hack-the-north-2018"><img className="LinkIconPanel" src={github_icon}/></a><b>Devpost:</b><a href="https://devpost.com/software/hack-the-north-2018-9oexmy"><img className="LinkIconPanel" src={devpost_icon}/></a></p>
          </div>
          <div class="w3-third w3-container">
            <img style={{height:"65%", width:"65%"}} src={simulator_panel}></img>
          </div>
        </div>

        <div class="w3-row w3-padding-64">
          <div class="w3-twothird w3-container">
            <h1>Search and Protect</h1>
            <p>A dashboard to find and monitor Twitter users at risk of self-harm using natural language processing. Made with Stdlib cloud functions and IBM Waston. Achieved Top 5 at QHacks 2018.</p>
            <p><b>Github:</b><a href="https://github.com/RunEMC/SearchAndPro.tech"><img className="LinkIconPanel" src={github_icon}/></a><b>Devpost:</b><a href="https://devpost.com/software/qhacks-2018"><img className="LinkIconPanel" src={devpost_icon}/></a></p>
          </div>
          <div class="w3-third w3-container">
            <img style={{height:"65%", width:"65%"}} src={searchandpro_panel}></img>
          </div>
        </div>

        <div class="w3-row">
          <div class="w3-twothird w3-container">
            <h1>Senior Sensor</h1>
            <p>A compact device to monitor the elderly through sudden movements and provides notifications to a caretaker through SMS. Made with Twilio's API and an Arduino. Won the Best Use of Long Range IOT from Ericsson Award and the Best use of Twilio API Award at ConU Hacks 2018.</p>
            <p><b>Github:</b><a href="https://github.com/lifeofcows/SeniorSensor"><img className="LinkIconPanel" src={github_icon}/></a><b>Devpost:</b><a href="https://devpost.com/software/elderly-notifications"><img className="LinkIconPanel" src={devpost_icon}/></a></p>
          </div>
          <div class="w3-third w3-container">
          <img style={{height:"75%", width:"75%"}} src={senior_panel}></img>
          </div>
        </div>

        <div class="w3-row">
          <div class="w3-twothird w3-container">
            <h1>Watson Front of Me</h1>
            <p>Visual recognition Mobile App with text to speech for the visually impaired. Made with IBM Watson's image recognition API and React Native for HackWestern 2017.</p>
            <p><b>Github:</b><a href="https://github.com/Vaibhav/WatsonFrontOfMe"><img className="LinkIconPanel" src={github_icon}/></a><b>Devpost:</b><a href="https://devpost.com/software/watson-front-of-me"><img className="LinkIconPanel" src={devpost_icon}/></a></p>
          </div>
          <div class="w3-third w3-container">
          <img style={{height:"75%", width:"75%"}} src={watson_panel}></img>
          </div>
        </div>

        <div class="w3-row">
          <div class="w3-twothird w3-container">
            <h1>Giphy Guesser</h1>
            <p>Mobile GIF guessing game made using React Native and Gihpy API. Created for PenApps 2017.</p>
            <p><b>Github:</b><a href="https://github.com/nicholaspun/giphyguesser"><img className="LinkIconPanel" src={github_icon}/></a><b>Devpost:</b><a href="https://devpost.com/software/relevant-tag-suggestions"><img className="LinkIconPanel" src={devpost_icon}/></a></p>
          </div>
          <div class="w3-third w3-container">
          <img style={{height:"75%", width:"75%"}} src={giphy_panel}></img>
          </div>
        </div>

        <div class="w3-row">
          <div class="w3-twothird w3-container">
            <h1>Alexa, my personal therapist</h1>
            <p>Makes Amazon Alexa into a personal therapist that listens to your problems with Amazon Alexa API. Made at Hack The Valley 2017.</p>
            <p><b>Github:</b><a href="https://github.com/ben-z/alexa-therapist"><img className="LinkIconPanel" src={github_icon}/></a><b>Devpost:</b><a href="https://devpost.com/software/alexa-my-personal-therapist"><img className="LinkIconPanel" src={devpost_icon}/></a></p>
          </div>
          <div class="w3-third w3-container">
          <img style={{height:"75%", width:"75%"}} src={alexa_panel}></img>
          </div>
        </div>

        <div class="w3-row">
          <div class="w3-twothird w3-container">
            <h1>Talcum Powder</h1>
            <p>A Facebook Messenger bot for medication reminders. Made with Python for QHacks 2017.</p>
            <p><b>Github:</b><a href="https://github.com/ZQingda/TalcumPowder"><img className="LinkIconPanel" src={github_icon}/></a><b>Devpost:</b><a href="https://devpost.com/software/talcumpowder"><img className="LinkIconPanel" src={devpost_icon}/></a></p>
          </div>
          <div class="w3-third w3-container">
          <img style={{height:"75%", width:"75%"}} src={talcum_panel}></img>
          </div>
        </div>

        <div class="w3-row w3-padding-64">
          <div class="w3-twothird w3-container">
            <h1>P2Secure</h1>
            <p>Created a Peer to Peer loan securing service with Ethereum smart contracts to hold collateral and ensure legitimacy. Won the best use of Blockchain at HackWestern 2016.</p>
            <p><b>Github:</b><a href="https://github.com/hygzhu/hackwestern-2016-P2Secure"><img className="LinkIconPanel" src={github_icon}/></a><b>Devpost:</b><a href="https://devpost.com/software/pay2secure"><img className="LinkIconPanel" src={devpost_icon}/></a></p>
          </div>
          <div class="w3-third w3-container">
          <img style={{height:"75%", width:"75%"}} src={p2s_panel}></img>
          </div>
        </div>
      </div>
    </div>
  );
}

const Projects = (props) => {
  return (
    <div>
      <button className="ViewProjectsButton" onClick={() => window.location.assign("\\")}>Back</button>
      <div class="w3-main">
        <div class="w3-row w3-padding-64">
          <div class="w3-twothird w3-container">
            <h1>Reddit Participation Bot</h1>
            <p>Collects data and Provides statistics on user activity in /r/uwaterloo by collecting comments and submissions over time. Made in Python with the PRAW library.</p>
            <p><b>Github:</b><a href="https://github.com/hygzhu/reddit-participation-bot"><img className="LinkIconPanel" src={github_icon}/></a></p>
          </div>
          <div class="w3-third w3-container">
            <img style={{height:"65%", width:"65%"}} src={uwaterloo_panel}></img>
          </div>
        </div>

        <div class="w3-row w3-padding-64">
          <div class="w3-twothird w3-container">
            <h1>Hearthstone Joke Website Template</h1>
            <p>A web template for a popular Hearthstone joke made in React.</p>
            <p><b>Github:</b><a href="https://github.com/hygzhu/hearthstone-joke-template"><img className="LinkIconPanel" src={github_icon}/></a></p>
          </div>
          <div class="w3-third w3-container">
            <img style={{height:"65%", width:"65%"}} src={hearthstone_panel}></img>
          </div>
        </div>

        <div class="w3-row w3-padding-64">
          <div class="w3-twothird w3-container">
            <h1>CSS Userscript</h1>
            <p>Reddit UI tool for the April Fools 2018 event to indicate how many "circles" a user belongs to and how many they have betrayed.</p>
            <p><b>Github:</b><a href="https://github.com/hygzhu/reddit-circle-of-trust-score"><img className="LinkIconPanel" src={github_icon}/></a></p>
          </div>
          <div class="w3-third w3-container">
            <img style={{height:"65%", width:"65%"}} src={userscript_panel}></img>
          </div>
        </div>

        <div class="w3-row w3-padding-64">
          <div class="w3-twothird w3-container">
            <h1>Webscraper</h1>
            <p>Python webscraper that scrapes important info from MyAnimeList.net. Made in Python using BeatufiulSoup.</p>
            <p><b>Github:</b><a href="https://github.com/hygzhu/python-mal-scraper"><img className="LinkIconPanel" src={github_icon}/></a></p>
          </div>
          <div class="w3-third w3-container">
            <img style={{height:"65%", width:"65%"}} src={mal_panel}></img>
          </div>
        </div>

        <div class="w3-row w3-padding-64">
          <div class="w3-twothird w3-container">
            <h1>Anime Song Trivia</h1>
            <p>A song guessing game made as a web app, android app and discord bot. The web version is made with react and redux and supports multiplayer with Websockets. The android version has over 3000+ downloads on the google play store.</p>
            <p><b>Web App Repo:</b><a href="https://github.com/hygzhu/anime_trivia"><img className="LinkIconPanel" src={github_icon}/></a><b>Android App Repo:</b><a href="https://github.com/hygzhu/mobile_trivia"><img className="LinkIconPanel" src={github_icon}/></a><b>Discord Bot Repo:</b><a href="https://github.com/hygzhu/discord-bot-song-trivia"><img className="LinkIconPanel" src={github_icon}/></a></p>
          </div>
          <div class="w3-third w3-container">
            <img style={{height:"65%", width:"65%"}} src={eye_panel}></img>
          </div>
        </div>

        <div class="w3-row w3-padding-64">
          <div class="w3-twothird w3-container">
            <h1>Clap Detection App</h1>
            <p>A simple Android app that plays audio after hearing two successive claps.</p>
            <p><b>Github:</b><a href="https://github.com/hygzhu/clap-detection-app"><img className="LinkIconPanel" src={github_icon}/></a></p>
          </div>
          <div class="w3-third w3-container">
            <img style={{height:"65%", width:"65%"}} src={clap_panel}></img>
          </div>
        </div>

        <div class="w3-row w3-padding-64">
          <div class="w3-twothird w3-container">
            <h1>Android Keyboard</h1>
            <p>A simple android keyboard with custom key mappings.</p>
            <p><b>Github:</b><a href="https://github.com/hygzhu/android-keyboard"><img className="LinkIconPanel" src={github_icon}/></a></p>
          </div>
          <div class="w3-third w3-container">
            <img style={{height:"65%", width:"65%"}} src={keyboard_panel}></img>
          </div>
        </div>

      </div>
    </div>
  );
}

class Project extends Component {

  constructor(props) {
    super(props);
    this.state = {
      title: props.title,
      text: props.text,
      desc: props.desc,
      link_images: props.link_images,
      links: props.links,
      image: props.image,
      showPopup: false,
      routing: props.routing
    }

    this.togglePopup = this.togglePopup.bind(this);
  }

  togglePopup() {
    window.location.assign(this.state.routing);
  }

  render() {
    return (
      <div className="ProjectPanel" onClick={() => this.togglePopup()}>
        <img className="PanelBackground" alt={"Project"} src={this.state.image} />
      </div>);
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js